import { useMutation } from '@tanstack/react-query';
import { Routes } from './routes';
import { apiClient } from '@/services/apiClient';
import type { OrderResponse } from '@/types/order';

export const useGetOrder = () => {
  return useMutation({
    mutationFn: async (orderId: string) => {
      const response = await apiClient.get<OrderResponse>(`${Routes.ORDER}/${orderId}`);
      return response;
    },
  });
};

export const useCancelOrder = () => {
  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.post(Routes.CANCEL_ORDER);
      return response;
    },
  });
};
